// "My size": header button + dialog. Saved in localStorage as {scale, size}; sizes offered are only those in stock
// (fetched on demand from ?section_id=ks-size-index). Saving opens the catalogue filtered to that size.
(() => {
  const me = document.currentScript;
  const SEARCH = me?.dataset.searchUrl || '/search', ROOT = me?.dataset.root || '/';
  const LABEL = { men: "Men's US", women: "Women's US", gs: 'GS / Kids US' }, SHORT = { men: 'M', women: 'W', gs: 'GS' };
  const get = () => { try { return JSON.parse(localStorage.getItem('ks.mySize')); } catch { return null; } };
  const put = v => { try { v ? localStorage.setItem('ks.mySize', JSON.stringify(v)) : localStorage.removeItem('ks.mySize'); } catch {} };
  let sizes = null, draft = null;

  function label() {
    const ms = get();
    document.querySelectorAll('[data-ks-mysize-label]').forEach(el => (el.textContent = ms ? `${SHORT[ms.scale]} ${ms.size}` : 'Set'));
    document.querySelectorAll('.ks-mysize').forEach(b => { b.classList.toggle('is-set', !!ms); b.setAttribute('aria-label', ms ? `My size: ${LABEL[ms.scale]} ${ms.size}. Change` : 'Set my size'); });
  }
  async function loadSizes() {
    if (sizes) return sizes;
    const r = await fetch(`${ROOT}?section_id=ks-size-index`);
    const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
    const raw = JSON.parse(doc.querySelector('[data-ks-sizes]').textContent);
    sizes = {};
    for (const k of Object.keys(raw)) {
      const m = new Map();
      raw[k].split('|').filter(Boolean).forEach(t => { const v = t.split('~')[1]; m.set(t.split('~')[0] + '~' + v, (m.get(t.split('~')[0] + '~' + v) || 0) + 1); });
      sizes[k] = [...m.entries()].sort((a, b) => a[0].localeCompare(b[0])).map(([key, n]) => [key.split('~')[1], n]);
    }
    return sizes;
  }
  function draw(dlg) {
    const sc = dlg.querySelector('[data-ks-ms-scales]'), sz = dlg.querySelector('[data-ks-ms-sizes]');
    // the buttons are rebuilt below; remember which one had focus so it keeps focus (and the modal keeps it)
    const was = dlg.contains(document.activeElement) ? document.activeElement : null;
    const refocus = was?.dataset.s ? `[data-s="${was.dataset.s}"]` : was?.dataset.v ? `[data-v="${CSS.escape(was.dataset.v)}"]` : null;
    sc.innerHTML = Object.keys(LABEL).map(s => `<button type="button" data-s="${s}" aria-pressed="${draft.scale === s}">${LABEL[s]}</button>`).join('');
    sc.querySelectorAll('button').forEach(b => b.onclick = () => { draft = { scale: b.dataset.s, size: null }; draw(dlg); });
    const list = sizes ? sizes[draft.scale] || [] : null;
    sz.innerHTML = !list ? '<span class="ks-muted">Loading sizes…</span>' : list.length
      ? list.map(([v, n]) => `<button type="button" class="ks-chip" data-v="${v}" aria-pressed="${draft.size === v}" aria-label="Size ${v}, ${n} pair${n === 1 ? '' : 's'}">${v}<small aria-hidden="true">${n}</small></button>`).join('')
      : '<span class="ks-muted">No sizes in stock for this scale.</span>';
    sz.querySelectorAll('.ks-chip').forEach(b => b.onclick = () => { draft.size = b.dataset.v; draw(dlg); });
    dlg.querySelector('[data-ks-ms-save]').disabled = !draft.size;
    if (refocus) (dlg.querySelector(refocus) || sc.querySelector('[aria-pressed="true"]'))?.focus();
  }
  function open() {
    const dlg = document.querySelector('[data-ks-mysize]');
    if (!dlg) return;
    draft = get() || { scale: 'men', size: null };
    draw(dlg); dlg.showModal();
    loadSizes().then(() => draw(dlg)).catch(() => { dlg.querySelector('[data-ks-ms-sizes]').innerHTML = '<span class="ks-muted">Could not load sizes.</span>'; });
  }
  function wire() {
    const dlg = document.querySelector('[data-ks-mysize]');
    if (!dlg || dlg.dataset.ready) return;
    dlg.dataset.ready = 1;
    dlg.querySelector('[data-ks-ms-save]').addEventListener('click', () => {
      put({ ...draft }); try { sessionStorage.removeItem('ks.noAuto'); } catch {}
      dlg.close(); label();
      const col = document.querySelector('[data-ks-plp]')?.dataset.col || 'all';
      location.href = `${SEARCH}?q=${encodeURIComponent(`size:${draft.scale}:${draft.size} in:${col}`)}&type=product`;
    });
    dlg.querySelector('[data-ks-ms-clear]').addEventListener('click', () => { put(null); dlg.close(); label(); try { sessionStorage.setItem('ks.noAuto', '1'); } catch {} });
  }
  document.addEventListener('click', e => { if (e.target.closest('[data-ks-mysize-open]')) { e.preventDefault(); open(); } });
  const boot = () => { wire(); label(); };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();
  addEventListener('storage', label);
})();
